import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { ProgressSpinner } from 'primereact/progressspinner';
import BlogTemplate from 'components/blog-template';
import ShopNavBar from 'pages/shop-home-page/shop-nav-bar';
import MarketplaceFooter from 'components/footer-marketplace/MarketplaceFooter';
import parse from 'html-react-parser';
import { Head } from 'components/head/Head';
import { getMarketContent } from 'utils/marketContent';
import { useHubspotBlog } from '../../hooks/userHooks';
import './index.scss';

export default function ShopBlogDetails() {
  const [currentBlog, setCurrentBlog] = useState<any>();
  const { blogID } = useParams();
  const market = getMarketContent();
  const dataBlogID = market.blogID;
  const { blogPosts, fetching } = useHubspotBlog(dataBlogID);

  useEffect(() => {
    const cb = blogPosts?.filter(blog => blog.id === blogID);
    const avilBlog = cb?.length > 0 ? cb[0] : undefined;
    setCurrentBlog(avilBlog);
  }, [blogID, blogPosts]);

  if (fetching || !currentBlog) {
    return (
      <div className="spinner-wrapper">
        <ProgressSpinner />{' '}
      </div>
    );
  }

  return (
    <>
      <Head
        link={`/blog/${currentBlog.id}`}
        title={currentBlog.htmlTitle}
        description={currentBlog.metaDescription}
        keywords={`blogs, natural medicine, health blogs, wellness blogs, author: ${currentBlog.authorName}, ${currentBlog.htmlTitle}`}
        addPostfixTitle
        imageCard={currentBlog.featuredImage}
        twitterUsername="@advancedmedmkt"
      />
      <ShopNavBar />
      <section id="shop-blog-details">
        <div className="grid px-4 md:px-2">
          <div className="col-12 lg:col-8">
            <img
              src={currentBlog.featuredImage}
              alt={currentBlog.htmlTitle}
              className="block w-full p-0"
              style={{ background: 'none', objectFit: 'cover' }}
            />
            <h1 className="blog-title">{parse(currentBlog.htmlTitle)}</h1>
            <p className="mb-4">
              <span className="mr-2">
                {format(new Date(currentBlog.publishDate), 'MMM')}
              </span>
              <span>{format(new Date(currentBlog.publishDate), 'dd')}</span>
            </p>
            <span className="blog-content">{parse(currentBlog.postBody)}</span>
          </div>
          <div className="col-12 lg:col-4">
            <div className="block">
              <h2 className="section_header">RECENT ARTICLES</h2>
              <div className="grid">
                {blogPosts?.slice(0, 3).map(blog => (
                  <div key={blog.index} className="col-12 mb-3">
                    <BlogTemplate {...blog} />
                  </div>
                ))}
              </div>
            </div>

            <div className="block">
              <h2 className="section_header">POPULAR ARTICLES</h2>
              <div className="grid">
                {blogPosts?.slice(0, 3).map(blog => (
                  <div key={blog.index} className="col-12 mb-3">
                    <BlogTemplate {...blog} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="block2">
          <h2 className="section_header">RELATED POSTS</h2>
          <div className="grid">
            {blogPosts?.slice(0, 4).map(blog => (
              <div key={blog.index} className="col-12 md:col-3 mb-3">
                <BlogTemplate {...blog} />
              </div>
            ))}
          </div>
        </div>
      </section>
      <MarketplaceFooter />
    </>
  );
}
